import inputColour from "@app/components/common/inputColour";

export default() => {
  inputColour();
}